import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsComponent } from './tabs.component';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [TabsComponent],
  imports: [CommonModule, IconModule],
  exports: [TabsComponent],
})
export class TabsModule {}
